import { render, staticRenderFns } from "./Timeline.vue?vue&type=template&id=880b09b2&scoped=true&"
var script = {}
import style0 from "./Timeline.vue?vue&type=style&index=0&id=880b09b2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "880b09b2",
  null
  
)

export default component.exports